export const SET_BOOKINGS_SEARCH = "SET_BOOKINGS_SEARCH";
export const SET_BOOKINGS_DATE_RANGE = "SET_BOOKINGS_DATE_RANGE";
export const SET_BOOKINGS = "SET_BOOKINGS";
export const SET_BOOKINGS_PAGE = "SET_BOOKINGS_PAGE";
export const SET_BOOKINGS_FILTER = "SET_BOOKINGS_FILTER";

export const SET_BOOKINGS_LOADING = "SET_BOOKINGS_LOADING";

export const SET_BOOKING_TIME_SLOTS = "SET_BOOKING_TIME_SLOTS";